"use client";
import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";

import useStore from "../../../lib/Store/useStore";
import { MOBILE_SCREEN_BREAKPOINT } from "../../../public/Constants/EnumConstants";
import { useMediaQuery } from "../../CustomHooks/UseMediaQuery";
import UserInitialsAvatar from "../UserInitialsAvatar";
import EcomHeader from "./EcomHeader";
import MobileSideMenu from "./MobileSideMenu";
import NavBarLinks from "./NavBarLinks";
import CurrencySelectorDropdown from "../../Molecules/CurrencySelectorDropdown";
import HeaderSearchBar from "./HeaderSearchBar";
import MobileCurrencySelectorHook from "../MobileCurrencySelectorHook";

const HeaderContent = () => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [dashboardDrawerOpen, setDashboardDrawerOpen] = useState(false);
    const { userData, countriesRates } = useStore();

    const breakPoint = useMediaQuery(MOBILE_SCREEN_BREAKPOINT);

    return (
        <>
            <nav
                className={`w-full h-15 lg:h-16 px-3 xl:px-10 bg-Primary_Default  flex justify-between items-center`}
            >
                <NavBarLinks
                    drawerOpen={drawerOpen}
                    setDrawerOpen={setDrawerOpen}
                    setDashboardDrawerOpen={setDashboardDrawerOpen}
                />

                <div
                    className={
                        "flex justify-between items-center max-w-full h-full gap-4"
                    }
                >
                    <HeaderSearchBar />

                    <UserInitialsAvatar
                        topBar
                        breakPoint={breakPoint}
                        userData={userData}
                    />
                    <EcomHeader
                        countries={countriesRates}
                        userData={userData}
                    />
                    {!breakPoint && <CurrencySelectorDropdown />}
                    {breakPoint && <MobileCurrencySelectorHook />}
                </div>
            </nav>
            {/* <div
                onClick={() => setDashboardDrawerOpen(!dashboardDrawerOpen)}
                className={
                    " transition-all delay-500 duration-500 opacity-0  translate-x-full  "
                }
                dir="ltr"
            >
                <div
                    className={
                        " fixed z-40 h-screen top-0 right-0  py-7 px-4 overflow-y-auto  bg-white w-screen sm:w-max "
                    }
                >
                    <div
                        className={"-mb-11"}
                        onClick={() =>
                            setDashboardDrawerOpen(!dashboardDrawerOpen)
                        }
                    >
                        <Image
                            src={CloseIcon}
                            width={25}
                            height={25}
                            alt="close-icon"
                        />
                    </div>
                    <DashboardSidebar
                        userData={userData}
                        setDashboardDrawerOpen={setDashboardDrawerOpen}
                    />
                </div>
            </div> */}
            <AnimatePresence>
                {breakPoint && drawerOpen && (
                    <motion.div
                        key="drawer"
                        initial={{ opacity: 0, x: "-100%" }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: "-100%" }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        className="fixed inset-0 w-screen h-screen flex flex-col p-6 overflow-y-auto z-40 bg-white"
                    >
                        <MobileSideMenu
                            drawerOpen={drawerOpen}
                            setDrawerOpen={setDrawerOpen}
                        />
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
};

export default HeaderContent;
